var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "answers_block" }, [
    _c("div", { staticClass: "button_add mb-4" }, [
      _c(
        "button",
        {
          staticClass:
            "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
          on: {
            click: function ($event) {
              return _vm.add_answer()
            },
          },
        },
        [
          _c("span", { staticClass: "fal fa-eject mr-1" }),
          _vm._v("\n\t\t\tДодати\n\t\t"),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "inf answers" },
      [
        _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
          _vm.answers.length > 0
            ? _c("div", [
                _c(
                  "ul",
                  {
                    staticClass: "pl-0",
                    staticStyle: { "list-style": "none" },
                  },
                  _vm._l(_vm.answers, function (item, idx) {
                    return _c(
                      "li",
                      { staticClass: "mt-2 list-style-none p-4 card" },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.title,
                                  expression: "item.title",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: { value: item.title },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(item, "title", $event.target.value)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-info waves-effect waves-themed",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.add_template(item)
                                    },
                                  },
                                },
                                [_vm._v("+ шаблон ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.remove_answer(idx)
                                    },
                                  },
                                },
                                [_vm._v("Видалити")]
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        item.templates.length > 0
                          ? _c(
                              "ul",
                              {
                                staticClass: "pl-2",
                                staticStyle: { "list-style": "none" },
                              },
                              _vm._l(item.templates, function (template, idx2) {
                                return _c(
                                  "li",
                                  { staticClass: "mt-2 list-style-none" },
                                  [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: template.title,
                                                expression: "template.title",
                                              },
                                            ],
                                            key: "ttl_" + idx2 + idx,
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: { value: template.title },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  template,
                                                  "title",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-append",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group-text",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-control d-flex custom-switch",
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              template.com_req,
                                                            expression:
                                                              "template.com_req",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "custom-control-input",
                                                        attrs: {
                                                          id:
                                                            "eventlog-switch-" +
                                                            idx2 +
                                                            idx,
                                                          type: "checkbox",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            Array.isArray(
                                                              template.com_req
                                                            )
                                                              ? _vm._i(
                                                                  template.com_req,
                                                                  null
                                                                ) > -1
                                                              : template.com_req,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                template.com_req,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  _vm.$set(
                                                                    template,
                                                                    "com_req",
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ])
                                                                  )
                                                              } else {
                                                                $$i > -1 &&
                                                                  _vm.$set(
                                                                    template,
                                                                    "com_req",
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      )
                                                                  )
                                                              }
                                                            } else {
                                                              _vm.$set(
                                                                template,
                                                                "com_req",
                                                                $$c
                                                              )
                                                            }
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "custom-control-label fw-500",
                                                          attrs: {
                                                            for:
                                                              "eventlog-switch-" +
                                                              idx2 +
                                                              idx,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tКоментар *\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-danger",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.remove_template(
                                                        item,
                                                        idx2
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Видалити")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }